import { render, staticRenderFns } from "./workspace_actions.vue.js?vue&type=template&id=09deb8b6&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./workspace_actions.vue?vue&type=template&id=09deb8b6&vue3"
import script from "./workspace_actions.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./workspace_actions.vue?vue&type=script&lang=js&vue3"
export * from "./workspace_actions.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./workspace_actions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports